import React from 'react'
import PropTypes from 'prop-types'
import colors from '../../../configuration/colors'
import Modal from '../../mini/Modal'
import FlexAlignCenter from '../../styled/FlexAlignCenter'
import { P2 } from '../../styled/typography/typography'
import {
  Alert,
  TrashIcon,
  AlertWrapper,
  CancelButton,
  Header
} from './_Styled'
import useLexicon from '../../../hooks/useLexicon'

const DeleteGuidance = ({ onCancel, onDelete }) => {
  const lexicon = useLexicon()

  return (
    <Modal
      width={500}
      top={50}
      autoHeight
      allowOverflow
    >
      <Alert>
        <AlertWrapper>
          <div
            style={{
              padding: '20px'
            }}
          >
            <TrashIcon />
            <Header as="h3">
              Are you sure you want to delete this {lexicon.skill.toLowerCase()} guidance from this {lexicon.focus_skill.toLowerCase()}?
            </Header>
            <P2 as="p">Once deleted, this cannot be undone.</P2>
          </div>
          <FlexAlignCenter
            style={{
              justifyContent: 'flex-end',
              padding: '20px',
              borderTop: `1px solid ${colors.rock}`
            }}
          >
            <CancelButton className="quest-btn btn-c" onClick={onCancel}>
              Cancel
            </CancelButton>
            <button
              className="quest-btn btn-d"
              style={{
                marginLeft: '10px',
                paddingLeft: '40px',
                paddingRight: '40px'
              }}
              onClick={onDelete}
            >
              Delete
            </button>
          </FlexAlignCenter>
        </AlertWrapper>
      </Alert>
    </Modal>
  )
}

DeleteGuidance.propTypes = {
  onCancel: PropTypes.func,
  onDelete: PropTypes.func
}

export default DeleteGuidance
